export default "__VITE_ASSET__B0oqrUv4__"